import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/sidebar.js';
import ListOfGames from './pages/listofgames.js';
import Landing from './pages/landing.js';
import Profile from './pages/profile.js';
import About from './pages/about.js';
import PrivacyPolicy from './pages/privacypolicy.js';
import SignIn from './components/SignIn.js'
import Register from './components/register.js'
import SignOutSuccess from './components/signoutsuccess.js'
import PasswordResetRequest from './components/passwordresetrequest.js'
import PasswordResetConfirm from './components/passwordresetconfirmation.js'
import ChangePassword from './components/passwordchangerequest.js';
import { useAppState } from './AppStateContext.js';
import Games from './components/games.js';
import Dashboard from './pages/dashboard.js';
import TradingDashboard from './pages/trading/TradingDashboard.js';
import OrderQueue from './pages/trading/OrderQueue.js';
import Positions from './pages/trading/Positions.js';
import Performance from './pages/trading/Performance.js';
import TradingSettings from './pages/trading/TradingSettings.js';
import TradingTerminal from './pages/trading/TradingTerminal.js';

const App = () => {
  // The slate's day lives in the URL (?date=YYYY-MM-DD), read by ListOfGames and
  // the sidebar -- not here. As App state it did not survive a reload.
  const { isAuthenticated, userTier, userProfile } = useAppState();


  return (
    <Router>
      <div className="App" id="outer-container">
        <Sidebar />
        <div id="page-wrap">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route 
            path="/signin" 
            element={
              isAuthenticated ? 
                <Navigate to="/" /> : 
                <SignIn/>
            } 
          />
          <Route path="/register" element={<Register />} />
          <Route 
            path="/league/NFL"
            element={
              <ListOfGames league="NFL" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/signout"
            element={<SignOutSuccess/>}
          />
          <Route
            path="/passwordresetrequest"
            element={<PasswordResetRequest />}
          />
          <Route
            path="/passwordresetconfirm/:uid/:token"
            element={<PasswordResetConfirm />}
          />
          <Route
            path="/passwordchangerequest"
            element={<ChangePassword />}
          />
          <Route
            path="/fixture/:id"
            element={<Games isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/fixture/:id/*"
            element={<Games isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/profile"
            element={<Profile isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated && userProfile?.is_staff ?
                <Dashboard /> :
                <Navigate to="/" />
            }
          />
          <Route path="/trading" element={
            isAuthenticated && userProfile?.is_staff ? <TradingDashboard /> : <Navigate to="/" />
          } />
          <Route path="/trading/orders" element={
            isAuthenticated && userProfile?.is_staff ? <OrderQueue /> : <Navigate to="/" />
          } />
          <Route path="/trading/positions" element={
            isAuthenticated && userProfile?.is_staff ? <Positions /> : <Navigate to="/" />
          } />
          <Route path="/trading/performance" element={
            isAuthenticated && userProfile?.is_staff ? <Performance /> : <Navigate to="/" />
          } />
          <Route path="/trading/settings" element={
            isAuthenticated && userProfile?.is_staff ? <TradingSettings /> : <Navigate to="/" />
          } />
          <Route path="/trading/terminal" element={
            isAuthenticated && userProfile?.is_staff ? <TradingTerminal /> : <Navigate to="/" />
          } />
          <Route 
            path="/league/NCAAF" 
            element={
              <ListOfGames league="NCAAF" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/NBA" 
            element={
              <ListOfGames league="NBA" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/EPL" 
            element={
              <ListOfGames league="EPL" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/NHL" 
            element={
              <ListOfGames league="NHL" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/NRL" 
            element={
              <ListOfGames league="NRL" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/MLS" 
            element={
              <ListOfGames league="MLS" isAuthenticated={isAuthenticated} />
            }
            />          
          <Route 
            path="/league/MLB" 
            element={
              <ListOfGames league="MLB" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/AFL" 
            element={
              <ListOfGames league="AFL" isAuthenticated={isAuthenticated} />
            }
            />
          <Route 
            path="/league/NCAAB" 
            element={
              <ListOfGames league="NCAAB" isAuthenticated={isAuthenticated} />
            }
            />      
        </Routes>
        </div>
      </div>

    </Router>
  )
}

export default App;
